import { Outlet, Route, Routes } from 'react-router-dom'
import { isMultilangPocEnabled } from '../../../constants/featureFlags'
import ErrorPage, { ErrorType } from '../../../controls/ErrorPage'
import { WaveAudiencesPage } from './WaveAudiencesPage'
import { WaveConfirmPage } from './WaveConfirmPage'
import { WaveDedupPage } from './WaveDedupPage'
import { WavePage } from './WavePage'
import { WaveQuestionnaireGuard } from './WaveQuestionnaireGuard'
import { WaveResultsPage } from './WaveResultsPage'
import { WaveStepPlaceholder } from './WaveStepPlaceholder'
import { WaveSurveyPage } from './WaveSurveyPage'
import { WaveTranslationsPage } from './WaveTranslationsPage'
import { useWaveLockRefusals } from './useWaveLockRefusals'

/**
 * One wave's steps, at /project/:projectId/wave/:waveId. Audiences, Survey and
 * Translations are the multi-market screens, each scoped to the wave's markets
 * and its own questionnaire.
 */
export const WaveRoutes = () => {
  useWaveLockRefusals()

  return (
    <Routes>
      {/* Results are read-only: never initialise a questionnaire just because a
          results-only viewer opens a wave (including a draft/unknown wave). */}
      <Route path="results" element={<WaveResultsPage />} />
      <Route path="results/:surveyId" element={<WaveResultsPage />} />
      <Route
        element={
          <WaveQuestionnaireGuard>
            <Outlet />
          </WaveQuestionnaireGuard>
        }
      >
        <Route index element={<WavePage />} />

        <Route path="audiences" element={<WaveAudiencesPage />} />
        <Route path="audiences/:surveyId" element={<WaveAudiencesPage />} />

        <Route path="survey" element={<WaveSurveyPage />} />

        <Route path="dedup" element={<WaveDedupPage />} />

        {/* Same gate as the multi-market flow: the translations editor is behind
          the multi-language POC flag, and WaveFlowBreadcrumb drops the step
          alongside it so it never links to a 404. */}
        {isMultilangPocEnabled() && (
          <Route path="translations" element={<WaveTranslationsPage />} />
        )}
        <Route
          path="tracking"
          element={<WaveStepPlaceholder step="Tracking" />}
        />
        <Route path="confirm" element={<WaveConfirmPage />} />

        <Route
          path="*"
          element={<ErrorPage errorType={ErrorType.NotFound404} />}
        />
      </Route>
    </Routes>
  )
}
